import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";
import { swalError, swalSuccess } from "@/utils/lib/swal";
import { SubmitButton } from "@/components/ui/button";
import {
  ProvincePayloadSchema,
  provincePayloadSchema,
  useProvinceCreate,
} from "@/api/province";
import { ProvinceFormFields } from "./ProvinceFormFields";
import { FormContainer } from "@/components/form/form-container";
import { Anchor } from "@/components/ui/anchor";
import { ErrorMessageFromResponse } from "@/api/types";

export function ProvinceCreateForm() {
  const form = useForm<ProvincePayloadSchema>({
    resolver: zodResolver(provincePayloadSchema),
  });
  const { mutate, isPending } = useProvinceCreate();
  const navigate = useNavigate();

  function handleSubmit(values: ProvincePayloadSchema) {
    mutate(
      { data: values },
      {
        onSuccess: () => {
          swalSuccess
            .fire({
              text: "Province has been created",
            })
            .then(() => navigate("/master-data/province"));
        },
        onError: (error) => {
          swalError.fire({
            text:
              (error as ErrorMessageFromResponse).response?.data.data ??
              error.message,
          });
        },
      },
    );
  }

  return (
    <FormContainer form={form} onSubmit={handleSubmit}>
      <ProvinceFormFields />
      <div className="ml-auto flex gap-x-2">
        <Anchor href="/master-data/province" mood="axiata-blue-outline">
          Cancel
        </Anchor>
        <SubmitButton loading={isPending} />
      </div>
    </FormContainer>
  );
}
